import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import debounce from 'debounce-promise'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const Services = ({ state: { services }, setState }) => {
  const { formatMessage } = useIntl()
  const [servicesOptions, setServicesOptions] = useState([])

  useEffect(() => {
    fetch('/rest/v2/order_services?search[hidden]=0&page=0&pageSize=50&orderField=name&orderDirection=1')
      .then(response => response.json())
      .then((services) => {
        setServicesOptions(services.map(({ uid, name }) => ({ value: uid, label: name }))) 
      })
      .catch((err) => {
        window.alert(`${formatMessage(messages.error)}: ${err}`);
      })
}, []);

  return (
    <div className="my-4">
      <div className="text-gray-500 mb-2">Services</div>
      <Select
        class
        value={services}
        onChange={(services) => setState((state) => ({ ...state, services }))}
        isMulti
        options={servicesOptions}
        openMenuOnFocus
        noOptionsMessage={({ inputValue }) => `${formatMessage(messages.noOptions)} '${inputValue}'`}
        loadingMessage={({ inputValue }) => `${messages.searching} '${inputValue}'..`}
        placeholder={formatMessage(messages.services)}
      />
    </div>
  )
}

export default Services
